    const toast = document.getElementById('toast');
    function showToast(message) {
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.toastTimer);
      window.toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
    }

    /* ---- Therapy packs: plan (fewer / more than 20) x stage ---- */
    const therapyState = { plan: 'low', stage: 'quickstart' };
    const PLAN_LABELS = { low: '20 or fewer cigarettes a day', high: 'more than 20 cigarettes a day' };

    /* Where each answer leads. Leave as null to open the plan on this page
       (#therapy-packs). To send people to a separate page instead, put its URL
       here, e.g. low: 'https://www.2baconil.com/pages/quit-plan-20-or-fewer'. */
    const PATHWAY_URLS = { low: null, high: null };

    function renderTherapy() {
      const { plan, stage } = therapyState;
      const context = document.getElementById('plan-context');
      if (context) {
        context.dataset.plan = plan;
        document.getElementById('plan-context-label').textContent = PLAN_LABELS[plan];
      }
      document.querySelectorAll('.therapy-tab').forEach(tab => {
        const on = tab.dataset.therapy === stage;
        tab.classList.toggle('active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('aria-controls', 'panel-' + plan + '-' + tab.dataset.therapy);
        const sub = tab.querySelector('small');
        if (sub && sub.dataset[plan]) sub.textContent = sub.dataset[plan];
      });
      document.querySelectorAll('.therapy-panel').forEach(panel => {
        const on = panel.dataset.plan === plan && panel.dataset.therapy === stage;
        panel.hidden = !on;
        panel.classList.remove('is-entering');
        if (on) { void panel.offsetWidth; panel.classList.add('is-entering'); }
      });
    }

    document.querySelectorAll('.therapy-tab').forEach(tab => {
      tab.addEventListener('click', () => { therapyState.stage = tab.dataset.therapy; renderTherapy(); });
    });

    document.querySelectorAll('.product-category-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.product-category-tab').forEach(item => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.product-category-panel').forEach(panel => panel.hidden = true);
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        document.getElementById('product-panel-' + tab.dataset.category).hidden = false;
      });
    });

    const productSection = document.getElementById('products');
    const storiesSection = document.getElementById('stories');
    if (productSection && storiesSection) {
      storiesSection.insertAdjacentElement('afterend', productSection);
    }

    /* ---- Finder: select an answer → CTA → pathway ---- */
    const finderCta = document.getElementById('finder-action');
    const finderResult = document.getElementById('finder-result');
    const FINDER_MESSAGES = {
      low: 'Lower-start pathway selected. Discuss the appropriate starting strength with your healthcare professional.',
      high: 'Higher-start pathway selected. Discuss the appropriate starting strength with your healthcare professional.'
    };
    let selectedPlan = null;

    function rememberPlan(plan) {
      try { sessionStorage.setItem('2baconilQuitPlan', plan); } catch (e) { /* storage unavailable */ }
    }

    function recallPlan() {
      const fromUrl = new URLSearchParams(window.location.search).get('plan');
      if (fromUrl === 'low' || fromUrl === 'high') return fromUrl;
      try {
        const stored = sessionStorage.getItem('2baconilQuitPlan');
        if (stored === 'low' || stored === 'high') return stored;
      } catch (e) { /* storage unavailable */ }
      return null;
    }

    function selectPlan(plan, { silent = false } = {}) {
      selectedPlan = plan;
      const input = document.querySelector('input[name="cigs"][value="' + plan + '"]');
      if (input) input.checked = true;
      document.querySelectorAll('.choice').forEach(choice => {
        choice.classList.toggle('selected', !!input && choice.contains(input));
      });
      finderResult.textContent = FINDER_MESSAGES[plan];
      finderCta.disabled = false;
      finderCta.setAttribute('aria-disabled', 'false');
      if (!silent) {
        finderCta.classList.remove('is-ready');
        void finderCta.offsetWidth;
        finderCta.classList.add('is-ready');
      }
      rememberPlan(plan);
    }

    document.querySelectorAll('input[name="cigs"]').forEach(input => {
      input.addEventListener('change', () => selectPlan(input.value));
    });

    finderCta.addEventListener('click', () => {
      if (!selectedPlan) return;
      rememberPlan(selectedPlan);

      if (PATHWAY_URLS[selectedPlan]) {
        window.location.assign(PATHWAY_URLS[selectedPlan]);
        return;
      }

      therapyState.plan = selectedPlan;
      therapyState.stage = 'quickstart';
      renderTherapy();
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('plan', selectedPlan);
        url.hash = 'therapy-packs';
        history.replaceState(null, '', url);
      } catch (e) { /* URL update not supported */ }
      document.getElementById('therapy-packs').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Restore a previous answer (from ?plan= or this browser session) */
    const recalled = recallPlan();
    if (recalled) {
      selectPlan(recalled, { silent: true });
      therapyState.plan = recalled;
    }
    renderTherapy();

    document.querySelectorAll('.faq button').forEach(button => {
      button.addEventListener('click', () => {
        const faq = button.closest('.faq');
        const open = faq.classList.toggle('open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    document.querySelectorAll('[data-product]').forEach(link => {
      link.addEventListener('click', event => {
        showToast(link.dataset.product + ' patch selected. Connect this button to the approved store URL.');
      });
    });

    const testimonialCards = document.querySelectorAll('#testimonialGrid .testimonial-card');
    if (!('IntersectionObserver' in window)) {
      testimonialCards.forEach(card => card.classList.add('in-view'));
    } else {
      const testimonialObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            testimonialObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      testimonialCards.forEach(card => testimonialObserver.observe(card));
    }

    const featureArt = document.querySelector('.feature-art');
    if (featureArt) {
      if (!('IntersectionObserver' in window)) {
        featureArt.classList.add('in-view');
      } else {
        const featureObserver = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) {
            featureArt.classList.add('in-view');
            featureObserver.disconnect();
          }
        }, { threshold: 0.3 });
        featureObserver.observe(featureArt);
      }
    }
